import { CommonModule } from '@angular/common';
import { Component, computed, input, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';

import { MatMenuModule } from '@angular/material/menu';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faEllipsisVertical, faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';

import { OptionsLibrarySet } from '../../../models/options-library/options-library-form.interface';

@Component({
  standalone: true,
  selector: 'empathy-options-library-set-card',
  templateUrl: 'options-library-set-card.component.html',
  styleUrl: './options-library-set-card.component.scss',
  imports: [CommonModule, FontAwesomeModule, MatButtonModule, MatCheckboxModule, MatMenuModule]
})
export class OptionsLibrarySetCardComponent {
  optionSet = input<OptionsLibrarySet>();
  checked = input<boolean>();

  selected = output<MatCheckboxChange>();
  delete = output<void>();
  duplicate = output<void>();
  edit = output<void>();

  optionsFiltered = computed(() => this.expanded$() ? this.optionSet().options : this.optionSet().options.slice(0, 3));

  expanded$ = signal(false);

  faChevronDown = faChevronDown;
  faChevronUp = faChevronUp;
  faEllipsisVertical = faEllipsisVertical;
}
